import React, { useState } from 'react'
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc'
import { useDispatch } from 'react-redux'

import styles from '../component-styles/manage-campaign-codes.module.scss'
import DeleteButtonWithConfirmation from './delete-button-with-confirmation'
// import { CampaignCodeGeneratorStructure,
import { ValidationChecks, GeneratorFields } from '../api-client/api-types'
import CampaignCodeAdministrationAddNew from './campaign-codes-administration-add-new'
import Button from './button'
import Row from './row'
import {
  // addGeneratorParameterAsync,
  getCampaignCodeGeneratorAsync,
} from '../store/actions'
import API from '../api-client/api-client'

const SortableItem = SortableElement(({ children, itemIndex, itemName }) => {
  return (
    <Row align="space-between" className={styles.row} odd={!!(itemIndex % 2)}>
      <p className={styles.label}>{itemName}</p>
      {children}
    </Row>
  )
})

interface SortableContainerProps {
  form: any
  onRemove: (fieldID: string) => void
}

const SortableWrapper = SortableContainer(
  ({ form, onRemove }: SortableContainerProps): React.ReactElement => {
    if (!form.paramDefs) {
      return <></>
    }

    return (
      <div>
        {form.paramDefs.map(
          (paramDef, index: number): React.ReactElement | null => {
            return (
              <SortableItem
                index={index}
                key={`${paramDef.fieldID} ${paramDef.fieldName}`}
                itemIndex={index}
                itemName={paramDef.fieldName}
              >
                <DeleteButtonWithConfirmation
                  odd={!!(index % 2)}
                  className={styles.deleteButtons}
                  onClick={(): void => {
                    onRemove(paramDef.fieldID)
                  }}
                >
                  <p>Delete this parameter?</p>
                </DeleteButtonWithConfirmation>
              </SortableItem>
            )
          },
        )}
      </div>
    )
  },
)

interface Props {
  // active: boolean
  // toggleActive: () => void
  form: any // CampaignCodeGeneratorStructure
  onRemove: (fieldID: string) => void
  onChangeOrder: (changes: {
    masterPrefix?: string
    validationChecks?: ValidationChecks[]
    paramSeparator?: string
    paramDefs: any[]
  }) => void
  onChange: (changes: {
    masterPrefix?: string
    validationChecks?: ValidationChecks[]
    paramSeparator?: string
    paramDefs: any[]
  }) => void
}

export default function ManageCampaignCodes({
  // active,
  // toggleActive,
  form,
  onRemove,
  onChangeOrder,
  onChange,
}: Props): React.ReactElement {
  const dispatch = useDispatch()
  const [showModal, setShowModal] = useState(false)

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const paramDefs = arrayMove(form.paramDefs, oldIndex, newIndex)
      const newParamDef = {
        ...form,
        paramDefs,
      }
      onChangeOrder(newParamDef)
    }
  }

  return (
    <>
      <div className={styles.codeList}>
        <SortableWrapper
          helperClass={styles.itemDragged}
          onRemove={onRemove}
          onSortEnd={onSortEnd}
          form={form}
          lockAxis="y"
        />
        <Button
          type="add"
          align="left"
          onClick={() => {
            setShowModal(true)
          }}
        >
          Add a new parameter
        </Button>
      </div>

      {showModal && (
        <CampaignCodeAdministrationAddNew
          active={showModal}
          toggleActive={(): void => setShowModal(!showModal)}
          onSubmit={async (nextNewParamDef: GeneratorFields) => {
            await API.addGeneratorParameter(nextNewParamDef)
            dispatch(getCampaignCodeGeneratorAsync())
            // onChange({
            //   ...form,
            //   paramDefs: [...form.paramDefs, nextNewParamDef],
            // })
          }}
        />
      )}
    </>
  )
}
